import React from 'react';
import './AdjustmentPanel.scss';
import { IconArrowRightTwo, IconClock } from '../../assets/icons';
import moment from 'moment';
import { FormattedDate } from 'react-intl';
import { TranslationUtils } from '../../utils';
import { useSelector } from 'react-redux';
import { TripState } from '../../types/trip.store.type';
import { AdjustmentPolicies } from 'guest-data-types-ts-lib/types';
import { TripAdjustmentResponse } from 'guest-data-types-ts-lib';
import { ExtendedStayPreviewRequest, TripAdjustmentPreviewResponse } from 'guest-data-types-ts-lib/types/adjustments';
import _ from 'lodash';
import { CheckDateTypes } from '../StayPanel/StayPanel';

interface AdjustmentPanelProps {
    adjustment: AdjustmentPolicies;
    preview?: TripAdjustmentResponse;
}

export const AdjustmentPanel: React.FC<AdjustmentPanelProps> = (props) => {
    const trip = useSelector((store: { trip: TripState }) => store.trip);
    const { reservation, stay } = trip;
    const { adjustment, preview } = props;

    if (!stay || !reservation) {
        return null;
    }

    const isAddNightFlow = adjustment === 'addNight' || adjustment === 'tripAddNight';
    const isLateCheckOutFlow = adjustment === 'lateCheckout';

    const renderAddNightNoteDescription = () => {
        const date = moment(stay.check_out_date_time).add(1, 'day').toString();
        let time;

        const checkOutTime = stay.late_check_out_purchased ? stay.late_check_out_time : stay.check_out_time;
        time = moment(`${stay.check_out_date} ${checkOutTime}`);
        return (
            <div className="stay-panel-check-date">
                <div className={'h5'} tabIndex={0}>
                    <h5>
                        <IconClock className="toggle-icon" />{' '}
                        <FormattedDate value={new Date(date)} month="short" day="numeric" weekday="short" />
                        {', '}
                        {moment(time).format('LT')}
                    </h5>
                </div>
            </div>
        );
    };

    const renderLateCheckoutNoteDescription = (preview: TripAdjustmentResponse) => {
        const lateCheckOutResponse = preview.adjustment as {
            name: 'lateCheckout';
            data: {
                check_in_date: string;
                check_in_date_time: string;
                check_out_date: string;
                check_out_date_time: string;
            };
        };

        const {
            data: { check_out_date, check_out_date_time },
        } = lateCheckOutResponse;

        const date = moment(check_out_date).toString();
        const time = moment(`${check_out_date} ${check_out_date_time}`);

        return (
            <div className="stay-panel-check-date">
                <div className={'h5'} tabIndex={0}>
                    <h5>
                        <IconClock className="toggle-icon" />{' '}
                        <FormattedDate value={new Date(date)} month="short" day="numeric" weekday="short" />
                        {', '}
                        {moment(time).format('LT')}
                    </h5>
                </div>
            </div>
        );
    };

    const renderAddExtendedStayNoteDescription = (preview: TripAdjustmentResponse) => {
        const checkIn = moment((preview.adjustment as ExtendedStayPreviewRequest).data.first_night).toString();
        const checkOut = moment((preview.adjustment as ExtendedStayPreviewRequest).data.last_night)
            .add(1, 'days')
            .toString();

        return (
            <div className="d-flex align-items-center stay-panel-check-date">
                <h5 className={'d-flex align-items-center gap-5'}>
                    <IconClock className="toggle-icon" />
                    <FormattedDate value={checkIn} month="short" day="numeric" weekday="short" />
                </h5>
                <span className={'svg-icon-arrow'}>
                    <IconArrowRightTwo />
                </span>
                <h5 className={'d-flex align-items-center gap-5'}>
                    <IconClock className="toggle-icon" />
                    <FormattedDate value={checkOut} month="short" day="numeric" weekday="short" />
                </h5>
            </div>
        );
    };

    return (
        <div>
            <div tabIndex={0}>
                <h1 className="page-title">
                    {/*Name of adjustment*/}
                    {isAddNightFlow && TranslationUtils.get('payment_form_add_night')}
                    {adjustment === 'adjustOccupancyAndPets' && TranslationUtils.get('manage_guests_capitalized')}
                    {adjustment === 'extendedStay' && TranslationUtils.get('extended_stay_capitalized')}
                    {adjustment === 'updatePetAdjustment' && TranslationUtils.get('manage_pets_title')}
                    {adjustment === 'lateCheckout' && TranslationUtils.get('late_check_out_capitalized')}
                    {adjustment === 'poolHeat' && TranslationUtils.get('pool_heat_capitalized')}
                </h1>
            </div>
            {isAddNightFlow && (
                <>
                    <span tabIndex={0} className={'note-adjustment'}>
                        {TranslationUtils.get('payment_form_add_night_note')}
                    </span>
                    <span className="title-adjustment">{renderAddNightNoteDescription()}</span>
                </>
            )}
            {adjustment === 'extendedStay' && !_.isNil(preview) && (
                <>
                    <span tabIndex={0} className={'note-adjustment'}>
                        {TranslationUtils.get('extended_stay_note_message')}
                    </span>
                    <span className="title-adjustment">{renderAddExtendedStayNoteDescription(preview)}</span>
                </>
            )}
            {isLateCheckOutFlow && !_.isNil(preview) && (
                <>
                    <span tabIndex={0} className={'note-adjustment'}>
                        {TranslationUtils.get('payment_form_add_late_check_out_note')}
                    </span>
                    <span className="title-adjustment">{renderLateCheckoutNoteDescription(preview)}</span>
                </>
            )}
        </div>
    );
};
